import React from 'react';

const Logo = ({ size = 'default', variant = 'glow' }) => {
  const sizes = {
    small: 'text-2xl',
    default: 'text-5xl',
    large: 'text-7xl'
  };

  const styles = {
    glow: {
      outer: {
        position: 'absolute',
        color: 'transparent',
        WebkitTextStroke: '3px rgba(255, 255, 255, 0.3)',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        letterSpacing: '0.05em',
        fontWeight: '900'
      },
      inner: {
        position: 'relative',
        color: 'transparent',
        WebkitTextStroke: '1.5px white',
        textShadow: '0 0 20px rgba(107, 70, 193, 0.8), 0 0 40px rgba(59, 130, 246, 0.6)',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        letterSpacing: '0.05em',
        fontWeight: '900'
      }
    },
    gradient: {
      outer: {
        position: 'absolute',
        color: 'transparent',
        WebkitTextStroke: '3px rgba(107, 70, 193, 0.3)',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        letterSpacing: '0.05em',
        fontWeight: '900'
      },
      inner: {
        position: 'relative',
        color: 'transparent',
        WebkitTextStroke: '1.5px #6B46C1',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        letterSpacing: '0.05em',
        fontWeight: '900'
      }
    }
  };

  return (
    <div className={`font-bold ${sizes[size]} relative`}>
      <span style={styles[variant].outer}>
        STOMP
      </span>
      <span style={styles[variant].inner}>
        STOMP
      </span>
    </div>
  );
};

export default Logo;